module.exports = __webpack_public_path__ + "img/Kanadensare.31e77077.jpg";